<template>
    <footer :class="footerClass" role="contentinfo" tabindex="0">
        <span class="cielo-footer__text" v-text="$ml.get('developedBy')" />
        <div v-if="isBBPayPayment" class="cielo-footer__logos-group">
            <img class="cielo-footer__logo" src="@/assets/img/logo-cielo--gray.svg" :alt="$ml.get('altLogo')" />
            <span class="cielo-footer__pipe">|</span>
            <img class="cielo-footer__logo" src="@/assets/img/bb-pay.svg" alt="BB Pay logo" />
        </div>
        <template v-else>
            <img class="cielo-footer__logo" src="@/assets/img/logo-cielo--gray.svg" :alt="$ml.get('altLogo')" />
            <span class="cielo-footer__pipe">|</span>
            <span class="cielo-footer__text">{{ $ml.get('securePayment') }}</span>
        </template>
    </footer>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                isBBPayPayment: 'bBPayPayment/getIsBBPayPayment',
            }),

            footerClass() {
              return {
                'cielo-footer': true,
                'cielo-footer--bbpay': this.isBBPayPayment
              };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .cielo-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 20px;

        span {
            font-size: 12px;
            font-weight: 600;
            line-height: 8px;
            color: #5C6A7B;
        }

        &__text {
            &:first-of-type {
                margin-right: 4px;
            }
        }

        &__logos-group {}

        &__logo {}

        &__pipe {
            margin: 0 8px;
        }
    }

    .cielo-footer--bbpay {
        flex-direction: column;

        span {
            margin-bottom: 8px;
        }

        & > * {
            flex: 1 0;
        }
    }
</style>
